import React from "react";
import "../../App.css";
import PropTypes from "prop-types";
import { Card, Form, Input, Button } from "antd";
import { useNavigate } from "react-router-dom";
import { LockOutlined, UserOutlined } from "@ant-design/icons";

const backgroundStyle = {
  backgroundImage: "url(/img/img-17.jpg)",
  backgroundRepeat: "no-repeat",
  backgroundSize: "cover",
  width: "100%",
  height: "100vh",
};

async function loginUser(credentials) {
  let url = "https://systems.smartchampion.in/api/om/login";
  return fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(credentials),
  })
  .then((data) => data.json())
  .catch((error)=>alert ('Please Enter correct Credentials'));
}

export default function Login({setToken}) {
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    let username=e.username;
    let password=e.password;
    const token = await loginUser({
      username,
      password,
    });
    setToken(token);
    navigate("/omCrPortal/app/home");
  };

  return (
    <div className="login-wrapper" style={backgroundStyle}>
      <Card
        style={{
          backgroundColor: "white",
          margin: "100px",
          borderRadius: "10px",
          height: "400px",
          width: "300px",
          padding: "10px",
        }}
      >
        <img src={`/img/Saarthi-blue.png`} alt="" />
        <p>Welcome to Saarthi OM Portal</p>
        <Form layout="vertical" name="login-form" onFinish={handleSubmit}>
          <Form.Item
            name="username"
            label="Name : "
            rules={[
              {
                required: true,
                message: "Please input your username",
              },
            ]}
          >
            <Input prefix={<UserOutlined className="text-primary" />} />
          </Form.Item>

          <Form.Item
            name="password"
            label={
              <div>
                <span>Password : </span>
              </div>
            }
            rules={[
              {
                required: true,
                message: "Please input your password",
              },
            ]}
          >
            <Input.Password
              prefix={<LockOutlined className="text-primary" />}
            />
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" block>
              Sign In
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
}

Login.propTypes = {
  setToken: PropTypes.func.isRequired,
};
